<template>
    <div>
        <b-alert v-if="from === 'Register' || from === 'Login'" sm="6" show dismissible variant="info">
            <p v-if="type === 'floorPlan'">{{$t('info.nbOfUnitAvailable', [unitAvail])}}</p>
            <p>{{$t('info.registerOrLogin')}}</p>
        </b-alert>
    </div>
</template>

<script>
export default {
mixins: [],
props: ['unitAvail','from', 'type'],
data() { return {}},
computed: {},
methods:{},
components: {}
}
</script>